<template>
  <el-dialog
    :visible.sync="showDialog"
    width="375px"
    @close="showDialog = false"
    class="sns-share-dialog"
    title="分享至"
    append-to-body
  >
    <div class="sns-btn fb-btn" @click="shareFb">
      <fps-icon type='facebook1' size="22" />
      <p>Facebook</p>
    </div>
    <div class="sns-btn line-btn" @click="shareLine">
      <fps-icon type='line11' size="22" />
      <p>LINE</p>
    </div>
  </el-dialog>
</template>

<script>
export default {
  model: {
    prop: 'show',
    event: 'change',
  },
  props: {
    show: Boolean,
    shareId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      showDialog: false,
    }
  },
  watch: {
    show(show) {
      this.showDialog = show
    },
    showDialog(show) {
      this.$emit('change', show)
    },
  },
  created() {
    this.showDialog = this.show
  },
  methods: {
    shareFb() {
      window.open(`https://www.facebook.com/sharer.php?u=https://share.nicee.tw/master?uuid=${this.shareId}`)
    },
    shareLine() {
      let input = document.createElement("textarea");
      input.value = '我在nicee等你呦～想玩遊戲就約我吧！https://share.nicee.tw/master?uuid=' + this.shareId
      document.body.appendChild(input);
      input.select();
      input.setSelectionRange(0, input.value.length), document.execCommand('Copy');
      document.body.removeChild(input);
      this.$message('已複製到剪貼薄，請到LINE上貼上喔！')
    }
  }
}
</script>

<style lang="scss">
.sns-share-dialog {
  /deep/ .el-dialog {
    border-radius: 20px;
    /deep/ .el-dialog__title {
      font-style: normal;
      font-weight: 500;
      font-size: 15px;
      text-align: center;
      color: #FA006E;
    }
  }
  .el-dialog__body {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}
</style>
 <style lang="scss" scoped>
.sns-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 280px;
  height: 48px;
  border-radius: 30px;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 48px;
  color: #FFFFFF;
  margin-bottom: 16px;
  cursor: pointer;
  i {
    margin-right: 12px;
  }
}
.fb-btn {
  background: #3D78EB;
}
.line-btn {
  background: #00B900;
}
 </style>
